import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import debounce from 'lodash.debounce';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
    },
    searchField: {
        width: '100%',
    },
}));

const ProductFilters = ({ keyword, onKeywordChange }) => {
    const classes = useStyles();
    const [inputValue, setInputValue] = React.useState(keyword || '');
    
    const debouncedKeywordChange = React.useMemo(
        () => debounce((value) => {
            onKeywordChange(value);
        }, 500),
        [onKeywordChange]
    );

    const handleKeywordChange = (event) => {
        const value = event.target.value;
        setInputValue(value);
        debouncedKeywordChange(value);
    };

    React.useEffect(() => {
        setInputValue(keyword || '');
    }, [keyword]);

    React.useEffect(() => {
        return () => {
            debouncedKeywordChange.cancel();
        };
    }, [debouncedKeywordChange]);

    return (
        <Paper className={classes.root} elevation={1}>
            <TextField
                className={classes.searchField}
                label="Search products..."
                placeholder="Search by code, description, category, or type"
                variant="outlined"
                size="small"
                value={inputValue}
                onChange={handleKeywordChange}
            />
        </Paper>
    );
};

export default ProductFilters;
